import { Link, LinkProps } from '@mui/material';
import { forwardRef, type ReactNode } from 'react';

type GridEntityLinkProps = Omit<LinkProps, 'target' | 'rel'> & {
  href: string;
  children: ReactNode;
};

/**
 * Entity name / detail link for grid cells.
 * Opens in the same tab by default.
 */
export const GridEntityLink = forwardRef<HTMLAnchorElement, GridEntityLinkProps>(function GridEntityLink(
  { href, children, ...linkProps },
  ref
) {
  return (
    <Link ref={ref} href={href} {...linkProps}>
      {children}
    </Link>
  );
});
